import ContactIdMappingListPagingResultModelBase from '../_generated/modelBases/contact-id-mapping-list-paging-result-model-base';

export default class ContactIdMappingListPagingResultModel extends ContactIdMappingListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
